import { render, staticRenderFns } from "./quick-order.vue?vue&type=template&id=ee1c0a08&scoped=true&"
import script from "./quick-order.vue?vue&type=script&lang=js&"
export * from "./quick-order.vue?vue&type=script&lang=js&"
import style0 from "./quick-order.vue?vue&type=style&index=0&id=ee1c0a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1c0a08",
  null
  
)

export default component.exports